import {Typography} from '@mui/material';
import React from 'react';

import {CopySection} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import {removeDuplicates} from 'presentation/utils';
import {StyledContainer, StyledStack} from './styles';
import {HealthPhonesSectionProps} from './types';

const {guideDetails} = translations['pt-br'].privateFlow.guideFlow;

export function HealthPhonesSection({provider}: HealthPhonesSectionProps) {
	const parsedPhones = provider.nuTelefone ? provider.nuTelefone.split('/').slice(0, -1) : [];
	const phones = removeDuplicates(parsedPhones);
	const hasPhones = phones.length > 0;

	return (
		<StyledContainer>
			<Typography variant="subtitle2" color="text.secondary">
				{guideDetails.phones}
			</Typography>
			{hasPhones ? (
				<StyledStack>
					{phones.map((item, index) => (
						<CopySection key={index} value={item} highlightedIcons />
					))}
				</StyledStack>
			) : (
				<Typography variant="body2" color="text.secondary">
					{guideDetails.emptyPhones}
				</Typography>
			)}
		</StyledContainer>
	);
}
